import type {TGamePlayer} from '@kapitalist/contract/types'
import GamePlayer from '~/models/game/GamePlayer'
import type ConcealedHand from '~/models/game/Hands/ConcealedHand'
import type Portfolio from '~/models/game/Portfolio'

/* a player whose hand we can't see */
export default class ConcealedGamePlayer extends GamePlayer {
  public hand: ConcealedHand
  constructor(playerData: TGamePlayer, portfolio: Portfolio, hand: ConcealedHand) {
    super(playerData, portfolio, hand)
    this.hand = hand
  }
}
